<template>
	<div>
		<cube-page type="catcheck-view" title="余额充值">
			<div slot="content">
				<div class="r_flex">
					<div class="r_icon">
						<van-icon name="gold-coin" size="80" />
						<!-- <van-icon name="balance" size="50" /> -->
					</div>
					<div class="r_num">{{parseFloat(amount).toFixed(2)}}</div>
					<van-button class="btn" type="info" @click="goZf">确认支付</van-button>
				</div>
			</div>
		</cube-page>
	</div>
</template>

<script>
	import CubePage from '../TP/cube-page.vue'
	import CubeView from '@/components/TP/cube-view'
	import * as util from '@/utils/network'
	import {
		_debounce
	} from '@/utils/fd'
  import {Toast} from "vant";
	export default {
		components: {
			CubePage,
			CubeView
		},
		data() {
			return {
				amount: this.$route.query.amount,
        channel: this.$route.query.channel,
        id: this.$route.query.id
			};
		},
		methods: {
			// 支付
			goZfun() {
				let that = this;
				var url = "/addons/litestore/api.mallbook/deposit"
				let param = {
					amount: that.amount,
          channel: that.channel,
          id: that.id
				}
				//这里直接调用网络接口
				util.post(url, param,
					function(result) {

						if (!result.code) {
              Toast(result.msg);
						} else {
							// return false;
							//这里发起支付
							console.log('这里能够符合支付条件');
							that.wx_pay_fun(result.data);
						}
					},
				);

			},
			goZf: _debounce(function(event) {
				event.preventDefault()
				this.goZfun()
			}, 300),
			wx_pay_fun(re) {
				var vm = this;
				if (typeof WeixinJSBridge == "undefined") { //微信浏览器内置对象。参考微信官方文档
					vm.$toast('请使用微信打开');
					return false;
					if (document.addEventListener) {
						document.addEventListener('WeixinJSBridgeReady', vm.onBridgeReady(re), false);
					} else if (document.attachEvent) {
						document.attachEvent('WeixinJSBridgeReady', vm.onBridgeReady(re));
						document.attachEvent('onWeixinJSBridgeReady', vm.onBridgeReady(re));
					}
				} else {
					vm.onBridgeReady(re);
				}
			},
			onBridgeReady(data) {
				var vm = this;
				//alert(JSON.stringify(data))
				WeixinJSBridge.invoke(
					'getBrandWCPayRequest', {
						"appId": data.appId,
						"nonceStr": data.nonceStr,
						"package": data.package,
						"signType": data.signType,
						"paySign": data.paySign,
						"timeStamp": data.timeStamp
					},
					function(res) {
						console.log(res.err_msg)
						if (res.err_msg == "get_brand_wcpay_request:ok") {
							vm.$toast('恭喜，支付成功');

						} else {
							vm.$toast('未支付或支付失败');
						}
						vm.$router.push({
							path: '/My'
						})
					}
				);
			},

		}
	}
</script>

<style lang="less" scoped>
	::v-deep.cube-page {
		.header {
			background: linear-gradient(to right, rgba(14, 122, 248) 20%, rgba(55, 151, 254));
			color: #fff;

			.cubeic-back {
				color: #fff;
			}
		}
	}

	.r_flex {
		background: #fff;
		padding: 20px 10px;
		display: flex;
		justify-content: center;
		flex-direction: column;
		text-align: center;

		.r_icon,
		.r_num {
			padding: 10px 0;
			text-align: center;
			color: #ff8a3a;
			font-weight: 600;
		}

		.r_num {
			font-size: 20px;
			color: #5f5f5f;
		}

		.btn {
			margin: 10px 0;
		}
	}
</style>
